import moment from "moment-timezone";
import { ISession } from "../../../../models/session";
import SpecialSession from "../../Sessions/SpecialSession";
import RegularSession from "../../Sessions/RegularSession";

import "./Event.scss";
import { isSpecialSession } from "../../../screens/EventPage/utils/utils";
import { isSessionArray } from "../../Sessions/utils/utils";
moment.tz.setDefault("Asia/Jerusalem");

interface IEventSession {
  communities: Array<any>; // TODO
  isFeed: boolean;
  session: ISession | ISession[];
  folderList?: Array<any>; // TODO
  loggedUser?: any; // TODO user type
  language?: string; // TODO maybe enum
  id: string;
}

const EventSession = ({ session, language, id, ...props }: IEventSession) => {
  if (isSessionArray(session) && session.length > 1) {
    return (
      <RegularSession
        session={session}
        language={language}
        {...props}
      />
    )
  }

  const _session = isSessionArray(session) ? session[0] : session;

  return !isSpecialSession(_session.sessionType) ? (
    <RegularSession
      session={_session}
      language={language}
      {...props}
    />
  ) : (
    <SpecialSession
      session={_session}
      language={language}
    />
  );
};

export default EventSession;
